import { FC, useEffect } from "react";
import { Route } from "react-router-dom";
import PrivateRoute, { PrivateRouteProps } from "routes/privateRoute";
import { Helmet } from "react-helmet";
import { AppRoute } from "routes";
import NewVersionModal from "components/layout/newVersionModal";

const APP_TITLE: string | undefined = process.env.REACT_APP_TITLE;

type RouteWrapperProps = FC<PrivateRouteProps | any> | typeof Route;

const onBackSpace = (e: KeyboardEvent) => {
  const tagName: string = (e.target as HTMLElement).tagName;

  if (e.keyCode === 8 || e.key === 'Backspace') {
    if (!['INPUT', 'TEXTAREA'].includes(tagName)) {
      e.preventDefault();
      e.returnValue = false;

      return false;
    }
  }
};

const RouteWrapper: FC<AppRoute> = (props: AppRoute) => {
  const { component: Component, layout, title, isPrivate, tabNav, ...rest } = props;

  const RouteComponent: RouteWrapperProps = isPrivate ? PrivateRoute : Route;
  const Layout = (layout ?? (({ children }: { children: React.ReactNode }) => <>{children}</>)) as FC<{ tabNav?: boolean; children: React.ReactNode }>;

  useEffect(() => {
    window.addEventListener('keydown', onBackSpace);

    return () => {
      window.removeEventListener('keydown', onBackSpace)
    };
  }, []);

  return (
    <>
      <RouteComponent
        {...rest}
        render={(props: RouteWrapperProps) => (
          <Layout tabNav={tabNav} {...props}>
            {title && (
              <Helmet>
                <title>
                  {APP_TITLE} - {title}
                </title>
              </Helmet>
            )}
            <Component {...props} />
          </Layout>
        )}
      />
      <NewVersionModal />
    </>
  );
};

export default RouteWrapper;
